@for (reaction of reactionsDataWithTooltip; track trackByReaction($index, reaction)) {
  <rt-reaction-button
    [reaction]="reaction.reaction"
    [counter]="reaction.count"
    [isActive]="reaction.currentUserReacted"
    rtTooltip
    [rtTooltipTemplate]="tooltipTemplate"
    [rtTooltipMaxWidth]="400"
    [rtTooltipHasTextAlignCenter]="true"
    (click)="toggle(reaction.reaction)"
  ></rt-reaction-button>
  <ng-template #tooltipTemplate>
    <span [innerHTML]="reaction.tooltip"></span>
  </ng-template>
}
@if (showLikeButton) {
  <rt-like-button (click)="toggleLike()"></rt-like-button>
}
<rt-add-reaction-button (select)="toggle($event)"></rt-add-reaction-button>
<ng-container [ngTemplateOutlet]="projectedContentTpl"></ng-container>
